import * as React from "react";
import { cs } from '@shared/utils/utils-classname';
import { makeObservable, observable } from 'mobx';
import { observer } from "mobx-react";

@observer
export class SidebarNavTabs extends React.Component<{
    activeId: any,
    onChange: (id: any) => void,
    onClose: () => void,
    isMobile: boolean,
    tabs: {
        id: any,
        icon: string,
        label: string
    }[]
}> {
    @observable overflowIndex = 0;
    @observable showOverflowMenu = false;
    readonly tabWidth = 44; // px, per design spec

    constructor(props: any) {
        super(props)
        makeObservable(this);
    }

    componentDidMount() {
        window.addEventListener('resize', _.debounce(this.calcOverflowIndex, 50));
        this.calcOverflowIndex();
    }

    calcOverflowIndex = () => {
        if (!this.props.isMobile) {
            this.overflowIndex = 0;
            return;
        }
        let overflowIndex = 0;
        for (let i = 0; i < this.props.tabs.length; i++) {
            if ((i * this.tabWidth) >= (window.innerWidth - (this.tabWidth * 2))) {
                overflowIndex = i;
                break;
            }
        }
        if (this.props.tabs.length - overflowIndex === 1) {
            overflowIndex = 0;
        }
        this.overflowIndex = overflowIndex;
    }

    render() {
        const visibleTabs = this.overflowIndex > 0 ? this.props.tabs.slice(0, this.overflowIndex) : this.props.tabs;
        const hiddenTabs = (this.overflowIndex > 0 && this.showOverflowMenu) ? this.props.tabs.slice(this.overflowIndex) : null;

        return <>
            {visibleTabs.map(tab => {
                return <div key={tab.id} className={cs('sidebar-panel__tab', {active: this.props.activeId == tab.id })}
                            onClick={() => this.onChange(tab.id)}
                            title={tab.label}>
                    <i className={tab.icon}/>
                </div>
            })}
            {!!this.overflowIndex && <div onClick={() => this.showOverflowMenu = !this.showOverflowMenu} className={cs('sidebar-panel__tab', { active: this.showOverflowMenu })}>
                <i className='iki iki-more' style={{ fontSize: '1.3em'}}/>
            </div>}

            {hiddenTabs && <div className='flex-column' style={{ position: 'fixed', bottom: 45, right: 0, zIndex: 50, background: 'white', boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.05)' }}>
                {hiddenTabs.map(tab => {
                    return <div key={tab.id} className={cs('sidebar-panel__tab', { active: this.props.activeId == tab.id })}
                                onClick={() => this.onChange(tab.id)}
                                title={tab.label}>
                        <i className={tab.icon}/>
                    </div>
                })}
            </div>}
        </>;
    }

    onChange(id: string) {
        this.showOverflowMenu = false;
        if (this.props.isMobile && id === this.props.activeId) {
            this.props.onClose();
        } else {
            this.props.onChange(id);
        }
    }
}
